const translations = {
  "en": {
    "~Unknown institution~": "~Unknown institution~",
    "Manage": "Manage",
    "Manual upload": "Manual upload"
  },
  "zh-tw": {
    "~Unknown institution~": "Unknown institution",
    "Manage": "管理",
    "Manual upload": "手動上傳"
  }
};

export default translations;
